import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e349bbaa")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  id: "broker-field",
  class: "p-field"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("No results")
const _hoisted_4 = { class: "drivers-toolbar" }
const _hoisted_5 = { class: "p-field-checkbox p-mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-weight":"normal"},
  for: "only_with_activity"
}, "Only drivers with a ticket", -1)
const _hoisted_7 = { class: "drivers-toolbar__count" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { style: {"color":"rgba(0,0,0,.5)"} }
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field-checkbox p-mt-2 p-mb-0" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "driver-content" }
const _hoisted_15 = {
  key: 1,
  class: "p-mr-1"
}
const _hoisted_16 = {
  key: 2,
  style: {"white-space":"nowrap"}
}
const _hoisted_17 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyAutocomplete = _resolveComponent("CompanyAutocomplete")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_WRSsFilters = _resolveComponent("WRSsFilters")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TicketStatus = _resolveComponent("TicketStatus")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DeductDialog = _resolveComponent("DeductDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('wrs.list.title')), 1)
    ]),
    (_ctx.imAdmin)
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 0,
          class: "p-mb-3",
          header: "Filters",
          toggleable: true,
          collapsed: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CompanyAutocomplete, {
                label: "Broker",
                type: 400,
                modelValue: _ctx.brokerSelected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.brokerSelected = $event)),
                onSelect: _ctx.onBrokerSelected,
                showDropdown: true
              }, null, 8, ["modelValue", "onSelect"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.imAdmin || _ctx.brokerSelected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_WRSsFilters, {
            filters: _ctx.advFilters,
            "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advFilters = $event)),
            onChange: _ctx.onFiltersChange
          }, null, 8, ["filters", "onChange"]),
          _createVNode(_component_DataTable, {
            ref: "dataTable",
            scrollable: true,
            scrollHeight: "500px",
            scrollDirection: "both",
            filters: _ctx.filters,
            "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event)),
            lazy: true,
            value: _ctx.dataset,
            loading: _ctx.requestPending,
            autoLayout: ""
          }, {
            empty: _withCtx(() => [
              _hoisted_3
            ]),
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_MultiSelect, {
                  modelValue: _ctx.selectedDriverIds,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDriverIds = $event)),
                  options: _ctx.driverOptions,
                  optionLabel: "label",
                  optionValue: "id",
                  dataKey: "id",
                  virtualScrollerOptions: { itemSize: 32 },
                  filter: true,
                  filterPlaceholder: "Search driver",
                  placeholder: "All drivers",
                  maxSelectedLabels: 2,
                  selectedItemsLabel: "{0} drivers selected",
                  class: "drivers-toolbar__select"
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.driverSort,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.driverSort = $event)),
                  options: _ctx.driverSortOptions,
                  optionLabel: "label",
                  optionValue: "value",
                  class: "drivers-toolbar__sort"
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Checkbox, {
                    id: "only_with_activity",
                    modelValue: _ctx.onlyWithActivity,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.onlyWithActivity = $event)),
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _hoisted_6
                ]),
                (_ctx.hasDriverFilters)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      type: "button",
                      label: "Clear",
                      icon: "pi pi-times",
                      class: "p-button-outlined",
                      onClick: _ctx.clearDriverFilters
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.visibleDrivers.length) + " / " + _toDisplayString(_ctx.brokerDrivers ? _ctx.brokerDrivers.length : 0) + " drivers ", 1),
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Refresh",
                  icon: "pi pi-refresh",
                  class: "rounded-btn raised-btn drivers-toolbar__refresh",
                  onClick: _ctx.loadData
                }, null, 8, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Time",
                style: {"width":"80px"},
                alignFrozen: "left",
                frozen: ""
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_DateFormatted, {
                    date: data.start_datetime,
                    format: "hh:mm A"
                  }, null, 8, ["date"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "WRS",
                style: {"width":"250px"},
                alignFrozen: "left",
                frozen: ""
              }, {
                body: _withCtx(({data}) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                      to: {
              name: _ctx.shiftRoute,
              params: { shiftId: data.id }
            },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" #" + _toDisplayString(data.id) + " " + _toDisplayString(data.code), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _hoisted_8,
                    _createTextVNode(" Max. : " + _toDisplayString(data.whitelist[0]?.trucks_required) + " | Engaged: " + _toDisplayString(data.whitelist[0]?.trucks_engaged), 1)
                  ])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleDrivers, (driver) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  style: {"width":"180px"},
                  key: driver.id
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(driver.fullname), 1),
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, _toDisplayString(driver.company_name), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_Checkbox, {
                            id: 'enable_self_accept_' + driver.id,
                            modelValue: driver.enable_self_accept,
                            "onUpdate:modelValue": ($event: any) => (driver.enable_self_accept = $event),
                            onChange: ($event: any) => (_ctx.updateEnableSelfAccept(driver)),
                            disabled: !!driver.isLoading,
                            binary: true
                          }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange", "disabled"]),
                          _createElementVNode("label", {
                            style: {"font-weight":"normal"},
                            for: 'enable_self_accept_' + driver.id
                          }, "Enable self accept WRS", 8, _hoisted_13)
                        ])
                      ])
                    ])
                  ]),
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_14, [
                      (data.driversById[driver.id]?.status === _ctx.DriverTicketStatus.ACCEPTABLE)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            type: "button",
                            label: "Accept",
                            onClick: ($event: any) => (_ctx.acceptTicket(data.id, driver.id)),
                            class: "p-button-outlined"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (data.driversById[driver.id]?.ticketId != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                            _createVNode(_component_router_link, {
                              to: {
                    name: _ctx.ticketRoute,
                    params: { ticketId: data.driversById[driver.id]?.ticketId }
                  },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ticket #" + _toDisplayString(data.driversById[driver.id]?.ticketId), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (data.driversById[driver.id]?.ticketId != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(data.driversById[driver.id]?.broker_deduct) + "% deduc. ", 1),
                            (data.driversById[driver.id]?.ticket_payment_status == null ||
                     data.driversById[driver.id]?.ticket_payment_status === _ctx.PaymentStatusEnum.PENDING ||
                     data.driversById[driver.id]?.ticket_payment_status === _ctx.PaymentStatusEnum.APPROVED)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.openModal(data.driversById[driver.id])),
                                  class: "p-ml-2 pointer"
                                }, "Edit", 8, _hoisted_17))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (data.driversById[driver.id]?.status === _ctx.DriverTicketStatus.ACCEPTED)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 3,
                            type: "button",
                            label: "Delete",
                            onClick: ($event: any) => (_ctx.deleteTicket(data.driversById[driver.id]?.ticketId, driver.id)),
                            class: "p-ml-1 p-button-danger"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (data.driversById[driver.id]?.ticketStatus !== undefined)
                        ? (_openBlock(), _createBlock(_component_TicketStatus, {
                            key: 4,
                            status: data.driversById[driver.id]?.ticketStatus,
                            class: "p-ml-3"
                          }, null, 8, ["status"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["filters", "value", "loading"])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_DeductDialog, {
      visible: _ctx.displayDeductDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.displayDeductDialog = $event)),
      driver: _ctx.selectedDriver,
      onOnChange: _ctx.updateTicket
    }, null, 8, ["visible", "driver", "onOnChange"])
  ]))
}